import { INewAccessToken, INewAccessTokenResponseDTO } from '../interfaces/new-access-token.interface';
import { IUser, IUserDTO } from '../interfaces/user.interface';

export class UserMapper {
  static fromDTO(dto: IUserDTO): IUser {
    return {
      firstName: dto.firstName,
      lastName: dto.lastName,
      avatarUrl: dto.avatarUrl,
      roles: dto.roles,
      token: dto.token,
      refreshToken: dto.refreshToken,
    };
  }
}

export class AccessTokenMapper {
  static mapNewAccessTokenDTOToINewAccessToken(newAccessTokenDto: INewAccessTokenResponseDTO): INewAccessToken {
    return {
      accessToken: newAccessTokenDto.token,
      refreshToken: newAccessTokenDto.refreshToken,
    };
  }
}
